// Mock data for World Winner Management Services

export const companyInfo = {
  name: "World Winner Management Services",
  tagline: "Your Trusted Partner in Manpower & Security Solutions",
  established: "2014",
  vision: "To be the most preferred organization for Manpower, Security & Hospitality Services.",
  mission: "Ensuring Total Customer Satisfaction with highest Business Standards.",
  description: "World Winner Management Services is a fast-growing organization in human resources and contracts. Established in 2014, we offer optimized and customized solutions for both domestic and out-of-state demands in infrastructure, erection, commissioning contracts, AMC, and skilled/unskilled manpower supply."
};

export const services = [
  {
    id: 1,
    title: "Security Services",
    description: "Professional security guards and armed security personnel for complete protection of your premises.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Manpower Solutions",
    description: "Skilled and unskilled manpower supply for various industries including civil, mechanical, and electrical.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Hospitality Staff",
    description: "Trained housekeeping, pantry, and support staff for maintaining world-class hospitality standards.",
    icon: "Briefcase"
  },
  {
    id: 4,
    title: "Infrastructure Services",
    description: "Complete infrastructure manpower for erection, commissioning contracts, and AMC services.",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Payroll Services",
    description: "Comprehensive payroll management and labor compliance services for seamless operations.",
    icon: "Calculator"
  },
  {
    id: 6,
    title: "Compliance Management",
    description: "Expert handling of factory compliances and labor law requirements to keep your business compliant.",
    icon: "FileCheck"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Deepak",
    role: "Managing Director",
    avatar: "/images/teammember/Deepak.png"
  },
  {
    id: 2,
    name: "Raj Kumar",
    role: "Chairman",
    avatar: null
  },
  {
    id: 3,
    name: "Ashok Kumar",
    role: "General Manager (Marketing & Operation)",
    avatar: "/images/teammember/Ashok.png"
  },
  {
    id: 4,
    name: "Dharamveer",
    role: "Field Manager",
    avatar: "/images/teammember/Dharamvir.png"
  },
  {
    id: 5,
    name: "Sonu Threja",
    role: "Accounts Head",
    avatar: "/images/teammember/Sonu.png"
  },
  {
    id: 6,
    name: "Yasmin",
    role: "Marketing Executive",
    avatar: "/images/teammember/Yasmin.png"
  },
  {
    id: 7,
    name: "Chitranjan",
    role: "Field Office",
    avatar: "/images/teammember/Chitranjan.png"
  },
  {
    id: 8,
    name: "Simon Partas",
    role: "Facility Instructor",
    avatar: "/images/teammember/Simon.png"
  },
  {
    id: 9,
    name: "Shergill",
    role: "Training Officer",
    avatar: "/images/teammember/Shergill.png"
  }
];

export const portfolioImages = [
  "/images/portfolio/project-1.svg",
  "/images/portfolio/project-2.svg",
  "/images/portfolio/project-3.svg",
  "/images/portfolio/project-4.svg",
  "/images/portfolio/project-5.svg",
  "/images/portfolio/project-6.svg",
  "/images/portfolio/project-7.svg",
  "/images/portfolio/project-8.svg",
  "/images/portfolio/project-9.svg"
];

export const contactInfo = {
  email: "info@worldwinner.co.in",
  phone: "+91 9953601030",
  addresses: [
    {
      title: "Head Office - Delhi",
      address: "RZ-190, Ground Floor, Dgarampura, Kakrola Road, Najafgarh, Delhi-110043"
    },
    {
      title: "Haryana Office",
      address: "Plot no. 2 & 3 Sector 52 Faridabad Haryana 121005"
    },
    {
      title: "Punjab Office",
      address: "131, Sajwalpur, The Balachaur, Distt Nawansahar, Punjab-144526"
    },
    {
      title: "Karnataka Office",
      address: "#758, LIG, 2nd Phase 13th B, Main Road, Yelahanka New Town, Bangalore-560064"
    }
  ],
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.272445!2d77.1234567!3d28.456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDI3JzI0LjQiTiA3N8KwMDcnMjQuNCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
};

export const clientLogos = [
  {
    name: "client-1",
    logo: "/images/logos/client-1.svg"
  },
  {
    name: "client-2",
    logo: "/images/logos/client-2.svg"
  },
  {
    name: "client-3",
    logo: "/images/logos/client-3.svg"
  },
  {
    name: "client-4",
    logo: "/images/logos/client-4.svg"
  },
  {
    name: "client-5",
    logo: "/images/logos/client-5.svg"
  },
  {
    name: "client-6",
    logo: "/images/logos/client-6.svg"
  },
  {
    name: "client-7",
    logo: "/images/logos/client-7.svg"
  },
  {
    name: "client-8",
    logo: "/images/logos/client-8.png"
  },
  {
    name: "client-9",
    logo: "/images/logos/client-9.png"
  },
  {
    name: "client-10",
    logo: "/images/logos/client-10.png"
  },
  {
    name: "client-11",
    logo: "/images/logos/client-11.png"
  },
  {
    name: "client-12",
    logo: "/images/logos/client-12.png"
  },
  {
    name: "client-13",
    logo: "/images/logos/client-13.png"
  },
  {
    name: "client-14",
    logo: "/images/logos/client-14.jpg"
  },
  {
    name: "client-15",
    logo: "/images/logos/client-15.png"
  },

];

export const certificates = [
  {
    id: 1,
    name: "Business Registration Number",
    type: "Registration",
    url: "https://customer-assets.emergentagent.com/job_company-web-58/artifacts/vxbl3zo8_Business%20registration%20number.pdf"
  },
  {
    id: 2,
    name: "Central Board of Direct Taxes",
    type: "Tax Certificate",
    url: "https://customer-assets.emergentagent.com/job_company-web-58/artifacts/25b7pmnh_Central%20board%20of%20Direct%20Taxes.pdf"
  },
  {
    id: 3,
    name: "Certificate of Establishment",
    type: "Establishment",
    url: "https://customer-assets.emergentagent.com/job_company-web-58/artifacts/0nkhb17i_Certificate%20of%20establishment.pdf"
  },
  {
    id: 4,
    name: "Delhi Registration Form C",
    type: "State Registration",
    url: "https://customer-assets.emergentagent.com/job_company-web-58/artifacts/egeg6mpp_delhi%20registration%20Form%20C.pdf"
  },
  {
    id: 5,
    name: "ESIC Registration",
    type: "Insurance",
    url: "https://customer-assets.emergentagent.com/job_company-web-58/artifacts/zty4ae20_ESIC%20Registration.pdf"
  },
  {
    id: 6,
    name: "ISO 9001:2015 Certificate",
    type: "Quality Certification",
    url: null,
    placeholder: true
  },
  {
    id: 7,
    name: "GST Registration",
    type: "Tax Registration",
    url: null,
    placeholder: true
  },
  {
    id: 8,
    name: "PAN Card",
    type: "Tax Document",
    url: null,
    placeholder: true
  },
  {
    id: 9,
    name: "Provident Fund Registration",
    type: "Employee Benefit",
    url: null,
    placeholder: true
  },
  {
    id: 10,
    name: "Trade License",
    type: "Business License",
    url: null,
    placeholder: true
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "Operations Manager",
    company: "Tech Solutions Pvt Ltd",
    rating: 5,
    text: "World Winner Management Services has been instrumental in providing us with skilled manpower. Their professionalism and dedication to quality service is commendable. We've been working with them for over 3 years now.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh"
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "HR Director",
    company: "Manufacturing Industries Ltd",
    rating: 5,
    text: "Outstanding security services! The team is well-trained, punctual, and highly professional. WWMS has exceeded our expectations in every aspect. Highly recommend their services to any organization.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priya"
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "Facility Manager",
    company: "Retail Chain India",
    rating: 5,
    text: "We've been using their hospitality and housekeeping services for our stores across multiple locations. The consistency in quality and their responsive support team makes them stand out from competitors.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Amit"
  },
  {
    id: 4,
    name: "Neha Gupta",
    position: "Project Director",
    company: "Infrastructure Developers",
    rating: 5,
    text: "Excellent infrastructure manpower solutions. WWMS provided us with skilled technicians and workers for our projects. Their compliance management is top-notch. A reliable partner for any construction project.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Neha"
  }
];